import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { usePageTitle } from "hooks/usePageTitle";

const OperationsTools = () => {
  usePageTitle("Operations Tools");
  const theme = useTheme();

  return (
    <Box
      p="1rem"
      bgcolor={theme.palette.background.alt}
      sx={{
        flex: 1,
        position: "relative",
        height: "100vh", // Take full viewport height minus margin
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ flexShrink: 0 }}>
        <Grid container alignItems="center">
          <Grid size={{ xs: 12 }} container justifyContent="flex-end"></Grid>
        </Grid>
      </Box>
      <Box
        borderRadius="0 0 1.5rem 1.5rem"
        bgcolor={theme.palette.background.alt}
        mt="60px"
        p="1rem"
        sx={{
          position: "absolute",
          inset: 0,
          top: "auto", // Override the inset:0 for top
          height: "calc(100% - 60px)", // Take remaining height after header
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Typography 
          variant="h3" 
          align="center"
          color={theme.palette.primary.main}
        >
          This feature is under the works, and it'll be available in the future in sha'Allah.
          <br/>
          <br/>
          It'll include tools like: <b>COT Generator</b>, <b>Document Encrypt/Decrypt</b>, and other tools as you guys see fit.
        </Typography>
      </Box>
    </Box>
  );
};

export default OperationsTools;
